'use client';

import { useState } from 'react';
import QuoteWinSimple from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinSimple';

interface FreeQuoteCardProps {
    pillLabel: React.ReactNode;
    children: React.ReactNode;
}

export default function FreeQuoteCard({ pillLabel, children }: FreeQuoteCardProps) {
    const [showFreeQuote, setShowFreeQuote] = useState(false);

    return (
        <div className="card-col">
            <span className="pill" onClick={() => setShowFreeQuote(true)}>
                {pillLabel}
            </span>
            {children}
            {showFreeQuote && <QuoteWinSimple callback={() => setShowFreeQuote(false)} />}
        </div>
    );
}
